<template>
  <section class="words">
    <div class="words_in">
    <h2 class="words_ttl"><span class="words_ttlTxt">Words</span></h2>
    <ol class="words_list">
       <li class="words_item words_item-1">
        <dl class="words_cont">
          <dt class="words_term">
            <ruby>人工神<rt>じんこうしん</rt></ruby><ruby>MAZEDOLL<rt>メイズドール</rt></ruby>
          </dt>
          <dd class="words_desc">
            <p class="words_descTxt">
         2XXX年、起こりうる最終戦争を見越して旧権力者達が当時の持ちうる技術を全て費やして完成させた「最終戦争から権力者を防衛し、選ばれた次人類とより適切な世界を作る為」に建造された7柱の機械群である。 
            </p>
            <p class="words_descTxt">
開発当初の資料からは読み取れなかったが、開発時の年代から考えても現実不可能な「人間と大差ない個性/感情」を有している。原理は不明。
            </p>
          </dd>
        </dl>
      </li>
       <li class="words_item words_item-2">
        <dl class="words_cont">
          <dt class="words_term">
           <ruby>空<rt>くう</rt>白<rt>はく</rt>戦<rt>せん</rt>争<rt>そう</rt></ruby>
          </dt>
          <dd class="words_desc">
            <p class="words_descTxt">
2XXX年、各国では紛争が絶えず続き、当時の権力者達は「選出された優秀な遺伝子を持つ個体の人類抹殺」を決定。来たる審判の日に権力者達はシェルターに篭り、核による一掃で浄化された世界の姿を目撃するはずだったのだが、この日に見られたのは星の成層圏外から爆散し降り注ぐ核の残骸と緩やかな火球、そして「7柱の機械の影」であった。</p>
            <p class="words_descTxt">
 影の主は暫し各国から発射された人類殲滅のための核兵器「天の火」を防ぎ、全滅するはずであった人類を全て守り抜き、自身たちの開発者を抹殺した。
            </p>
          </dd>
        </dl>
      </li>
     <li class="words_item words_item-3">
        <dl class="words_cont">
          <dt class="words_term">
           <ruby>反陽子炉<rt>はんようしろ</rt></ruby>／マイクロカーブラックホール<ruby>循環機構<rt>じゅんかんきこう</rt></ruby>
          </dt>
          <dd class="words_desc">
            <p class="words_descTxt">
人工神の基礎エネルギーとなっている機構であり、一説では完成当初にL国の粒子加速器を応用し、別宇宙との境界線を一時的に解放し、シュヴァルツシルト半径から得られる「おおよそ5次元的な力」を反陽子炉に蓄積し、放出する為に設けられた機構なのではないかと言われているが、明確な構造/目的は分かっていない。</p>
<p class="words_descTxt">
理論上、ほぼ無尽蔵のエネルギーを取り出す事が可能で、これの使用にあたっては人工神達も相当な消耗をするようで「人類の利点となる場合」にのみこの機構の発動されるようだ。</p>
          </dd>
        </dl>
      </li>

         <li class="words_item words_item-4">
        <dl class="words_cont">
          <dt class="words_term">
            <ruby>世界<rt>せかい</rt>連盟<rt>れんめい</rt></ruby>
          </dt>
          <dd class="words_desc">
            <p class="words_descTxt">
人工神の出現後、世界全体を「平等」としより良い世界を作り上げるために形成された連盟。</p><p class="words_descTxt">
連盟諸国に国境は存在するが、「国間での問題に武力の行使は恒久的に禁ずる」という掟の元、人類間での戦争は行われていない。
また、各国では人工神が統率を担っており、諸国への対応や連携の最終判断を人類に適切となる形で決定している。</p>
          </dd>
        </dl>
      </li>
      <li class="words_item words_item-5">
        <dl class="words_cont">
          <dt class="words_term">
           <ruby>王宮<rt>おうきゅう</rt></ruby>

          </dt>
          <dd class="words_desc">
            <p class="words_descTxt">
各国にはそれぞれ、王が棲む城とも言える場所が存在している。
それぞれの国で様々な形をとっているが、総称して王宮と呼ばれ、国の政治の中心となっている。 </p>
          </dd>
        </dl>
      </li>
    <li class="words_item words_item-6">
        <dl class="words_cont">
          <dt class="words_term">
           <ruby>自然的脅威<rt>しぜんてききょうい</rt></ruby>
          </dt>
          <dd class="words_desc">
            <p class="words_descTxt">
現在、各国は戦争状態になく、それぞれに役割が与えられ共存の動きを取っている。
中でも人的な要因でなく人類を脅かす可能性がある現象や事柄を総称して「自然的脅威」と呼ぶ。</p>
<p class="words_descTxt">
特にアルバディトスやガムラドは、この自然的脅威に対抗しうる鍛錬と武装を有している。
</p>
          </dd>
        </dl>
      </li>
<li class="words_item words_item-7">
        <dl class="words_cont">
          <dt class="words_term">
          <ruby>思考装置<rt>しこうそうち</rt></ruby>
          </dt>
          <dd class="words_desc">
            <p class="words_descTxt">
              空白戦争から人工神出現までの期間に人類の持つ技術を集約し開発された、人の思考伝達パルスをエネルギー源に変換し、様々な機能を併せ持ち生活を補助する機械。

            </p>
            <p class="words_descTxt">
連絡手段として、また娯楽の手段、仕事用具として幅広く使われており、ほとんどの家庭および個人が所持しており、世界連盟内全土に普及している。
            </p>
          </dd>
        </dl>
      </li>
    <li class="words_item words_item-8">
        <dl class="words_cont">
          <dt class="words_term words_term-en">
         <ruby>transfix<rt>トランスフィックス</rt></ruby>
          </dt>
          <dd class="words_desc">
            <p class="words_descTxt">
     現マルハティア国にて普及された音楽媒体。


            </p>
            <p class="words_descTxt">
「失われた形をリバイバルさせる」というテーマらしく、国内でも予想以上の売り上げを記録した。
マルハティアに入国すれば、若者がこの透明な媒体を身につけているのが見られる。
            </p>
          </dd>
        </dl>
      </li>
     <li class="words_item words_item-9">
        <dl class="words_cont">
          <dt class="words_term">
          <ruby>機神教<rt>きしんきょう</rt></ruby>／<ruby>機神祭<rt>きしんさい</rt></ruby>
          </dt>
          <dd class="words_desc">
            <p class="words_descTxt">
 空白戦争の後、旧支配者の消えた世界では宗教観が混濁、人類には指標となる存在が必要であったが、人工神の出現による全土に渡る王の統率が宗教観にも影響を及ぼし、機神教という統一された宗教を作り上げた。 </p>
<p class="words_descTxt">
各国では空白戦争記念日に、王を讃えるための祭がそれぞれの国のスタイルで行われる。 これが機神祭である。 尚、メイズドール達はこの事実を別段快く思ってはいないらしい。
            </p>
            
          </dd>
        </dl>
      </li>
   <li class="words_item words_item-10">
        <dl class="words_cont">
          <dt class="words_term">
          <ruby>太陽<rt>たいよう</rt></ruby>の<ruby>石<rt>いし</rt></ruby>サンプル<ruby>回収事件<rt>かいしゅうじけん</rt></ruby>
          </dt>
          <dd class="words_desc">
            <p class="words_descTxt">
            MAZEDOLL::IV【Varerius(ヴァレリウス)】によって、一時的に国家の統制が人類側に託され、王であるIVとの交信が途絶えた期間の事。

            </p>
            <p class="words_descTxt">
この時、IVは期間と同時に「新たなエネルギー源の研究をマルハティアへ任せたい。第1惑星の鉱物の回収は完了した。サンプルを送れ。」と言ったという。
IVは恐らく恒星「太陽」の石を回収したと見られ、これが真実であれば、人工神は5778K(摂氏5505℃)まで耐えうる装甲を持つということになる。
            </p>
          </dd>
        </dl>
      </li>
<li class="words_item words_item-11">
        <dl class="words_cont">
          <dt class="words_term words_term-en">
          <ruby>Personal<rt>パーソナル</rt></ruby>&nbsp;<ruby>Causality<rt>カジュアリティ</rt></ruby>&nbsp;<ruby>Overwrite<rt>オーバーライト</rt></ruby>&nbsp;<ruby>Effect<rt>エフェクト</rt></ruby>
          </dt>
          <dd class="words_desc">
            <p class="words_descTxt">
              詳細は不明だが、各機体が怒りを感じた際や極端な感情をあらわにした時、機体が対象とする人間に特定の効果が現れるとされている人工神の特殊能力。

              </p>
          
   
          </dd>
        </dl>
      </li>

    </ol>
    </div>
  </section>
</template>

<script>
export default{
  function(){
    /* eslint-disable */
FONTPLUS.setFonts(['FP-HiraKakuProN-W6']);
FONTPLUS.reload(false)
  }
}

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.words {
  background: #F3F3F3;
  padding-top: 48px;
  @include mq(sm){
    padding-top: 16px;
  }
  &_in{
    max-width: 1600px;
    margin:0 auto;
    padding:0 12px;
    @include mq(sm){
      padding: 0 12px 12px;
    }
  }
  &_ttl {
    font-family: 'DIN Next LT W01 Bold', 'Avenir', Helvetica, Arial, sans-serif;

    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: .05em;


    &::after {
      content: '';
      width: 18px;
      height: 18px;
      display: inline-block;
      background: url(../assets/icon_suffix.svg) center center no-repeat;
      vertical-align: middle;

      @include mq() {}
    }
  }

  &_ttlTxt {
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
  }

  &_list {
    
    padding: 24px 0;
    list-style: none;
    counter-reset: word;
    display: flex;
    flex-wrap: wrap;
   //     justify-content: space-between;
      @include mq(sm){
    margin-top:12px;
    padding: 0;
  }

  }

  &_item {

    width: 33%;
    border: solid 16px #f3f3f3;
    box-sizing: border-box;
    position: relative;
        margin-bottom: 8px;
        @media screen and (min-width:1000px){
        &:nth-child(3n+1){
          border-left: none;
        }
        &:nth-child(3n){
          border-right: none;
        }
        }
        @include mq(lg){
           &:nth-child(2n+1){
          border-left: none;
        }
        &:nth-child(2n){
          border-right: none;
        }
        }
         @include mq(lg){
           &:nth-child(2n+1){
          border-left: none;
        }
        &:nth-child(2n){
          border-right: none;
        }
        }
      &::after{
      content:'';
      width: 16px;
      height: 16px;
      position: absolute;
      right: 4px;
      bottom: 4px;
      background: url(../assets/icon_suffix.svg);
      background-size: 16px;
      opacity: .2;
    }
    @include mq(lg){
      width: 50%;
    }
    @include mq(){
      width: 100%;
      border:0;
    }
    @include mq(sm){
     // padding:6px 0;
 
    }

  }

&_cont{
    //  background-color: #fff;
    padding: 28px 28px 48px;
    position: relative;
    overflow: hidden;
text-align: center;
    &::before {
      counter-increment: word;
      content: counter(word, decimal-leading-zero);
      background-color: #000;
      color: #fff;
      position: absolute;
      left: 0;
      top: 0;
      clip-path: polygon(0% 0%, 100% 0%, 0% 100%);
      padding:6px 26px 26px 6px;
      font-family: 'DIN Next LT W01 Bold', 'Avenir', Helvetica, Arial, sans-serif;
      font-size: 14px;
    }
  
}
  &_desc {
    font-size: 12px;
    margin-top: 24px;
    text-align: justify;

    
  }

  &_term {
    text-align: center;
    font-family: 'DIN Next LT W01 Bold','FP-HiraKakuProN-W6', sans-serif;
    letter-spacing: .1em;
    display: inline-block;
    position: relative;
    padding:0 1em;
  font-weight:700;
    font-size: 18px;

line-height: 2;
    &-en{
      letter-spacing: .05em;
      hyphens: auto;
      font-weight: normal;
    }
    &::before{
      content:'';
      font-size: 12px;
      color: #ccc;
      position: absolute;
      left: 0;
      top: 0;
      width:4px;
      height:calc(100% - 8px);
      border-top: solid 1px #ccc;
      border-bottom: solid 1px #ccc;
      border-left:solid 1px #ccc;

  @include mq(sm){
   // margin-top: -.3em;
  }
    }
        &::after{
      content:'';
      font-size: 12px;
      color: #ccc;
      position: absolute;
      right: 0;
      top: 0;
      width:4px;
      height:calc(100% - 8px);

      border-top: solid 1px #ccc;
      border-bottom: solid 1px #ccc;
      border-right:solid 1px #ccc;
      @include mq(sm){
  // margin-top: -.3em;
  }

    }
    ruby{
      ruby-align:center;
    }
rt{
  letter-spacing: normal;
  font-weight: normal;
  ruby-align:center;
    font-family:  'FP-HiraKakuProN-W3', sans-serif;

}
  }

  &_descTxt {
    line-height: 1.75;
    &+& {
      margin-top: 1em;
    }
  }
}
$words_num: 11;
@for $i from 1 through $words_num {
  .words_item-#{$i}{
   background:#fff url(../assets/code_#{$i}.svg) left bottom no-repeat;
  }
}
</style>
